(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["s_timeline"] && !Shopify.designMode) return;
  try {
    
!function(){
  function e(e){
    this.element=e,
    this.blocks=this.element.getElementsByClassName("js-cd-block"),
    this.images=this.element.getElementsByClassName("js-cd-img"),
    this.contents=this.element.getElementsByClassName("js-cd-content"),
    this.offset=.8,
    this.hideBlocks()
  }

  e.prototype.hideBlocks=function(){
    if(!(!1 in document.documentElement))
      for(var e,t=this,s=0;s<this.blocks.length;s++)
        e=s,
        t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(
          t.images[e].classList.add("cd-is-hidden"),
          t.contents[e].classList.add("cd-is-hidden")
        )
  },

  e.prototype.showBlocks=function(){
    if(!(!1 in document.documentElement))
      for(var e,t=this,s=0;s<this.blocks.length;s++)
        e=s,
        t.contents[e].classList.contains("cd-is-hidden")&&
        t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(
          t.images[e].classList.add("s-timeline__img--bounce-in"),
          t.contents[e].classList.add("s-timeline__content--bounce-in"),
          t.images[e].classList.remove("cd-is-hidden"),
          t.contents[e].classList.remove("cd-is-hidden")
        )
  };

  var t,
      s=document.getElementsByClassName("js-s-timeline"),
      n=[],
      i=!1;

  if(s.length>0){
    for(var o=0;o<s.length;o++)
      t=o,n.push(new e(s[t]));

    window.addEventListener("scroll",function(e){
      i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))
    })
  }

  function c(){
    n.forEach(function(e){
      e.showBlocks()
    }),
    i=!1
  }
}();

  } catch(e) { console.error(e); }
})();
})();
